import type {
  ProgramFixedContentRowUpsert,
  ProgramProgressCellUpsert,
  ProgramScopedContentRowUpsert,
} from '../types/domain';

import { normalizeProgramLearningContentColumnsForStorage } from './programLearningContentFields';

export const PROGRAM_CONTENT_TEXT_FIELDS = [
  'timetable_text',
  'unit_text',
  'learning_text',
  'page_text',
  'assistant_page_text',
  'current_period_text',
  'total_period_text',
  'material_text',
  'record_cross_curricular_text',
  'record_memo_text',
  'record_evaluation_text',
  'record_class_text',
] as const;

export type ProgramContentTextField = (typeof PROGRAM_CONTENT_TEXT_FIELDS)[number];

export function textForDisplay(value: string | null | undefined): string {
  return value ?? '';
}

export function textForStorage(value: string | null | undefined): string | null {
  const s = String(value ?? '').trim();
  return s ? s : null;
}

export function normalizeProgramContentTextFieldsForStorage<
  T extends Partial<Record<ProgramContentTextField, string | null | undefined>>,
>(row: T): T {
  const next = { ...row };
  PROGRAM_CONTENT_TEXT_FIELDS.forEach((field) => {
    if (field in next) {
      (next as Record<ProgramContentTextField, string | null>)[field] = textForStorage(next[field]);
    }
  });
  return next;
}

export function normalizeScopedContentRowForStorage(row: ProgramScopedContentRowUpsert): ProgramScopedContentRowUpsert {
  const normalized = normalizeProgramLearningContentColumnsForStorage(normalizeProgramContentTextFieldsForStorage(row));
  return { ...normalized, learning_note: normalized.learning_note ?? '' };
}

export function normalizeFixedContentRowForStorage(row: ProgramFixedContentRowUpsert): ProgramFixedContentRowUpsert {
  const normalized = normalizeProgramLearningContentColumnsForStorage(normalizeProgramContentTextFieldsForStorage(row));
  return { ...normalized, learning_note: normalized.learning_note ?? '' };
}

export function normalizeProgramProgressCellForStorage(row: ProgramProgressCellUpsert): ProgramProgressCellUpsert {
  const normalized = normalizeProgramLearningContentColumnsForStorage(normalizeProgramContentTextFieldsForStorage(row));
  return { ...normalized, learning_note: normalized.learning_note ?? '' };
}
